// extracted by mini-css-extract-plugin
module.exports = {"blink":"animations_blink__3pPAa","blink_delayed":"animations_blink_delayed__G1O4a","heart_beat":"animations_heart_beat__1USgz"};